import React, {useContext} from 'react';
import {useIntl} from 'react-intl';

import {sendToStatist} from '@time-webkit/statist';
import {FileAttachmentsList} from '@time-webkit/all/organisms/file-attachments-list';

import FilePreviewModal from 'components/file_preview_modal';
import PostContext from 'components/post_view/post_context';
import {type FileInfo} from '@mattermost/types/files';
import {
    getFileThumbnailUrl, getFileUrl, getFileDownloadUrl, getFilePreviewUrl,
} from 'mattermost-redux/utils/file_utils';
import {ModalIdentifiers} from 'utils/constants';
import {copyToClipboard} from 'utils/copy_to_clipboard';

import {FileAttachmentMenu} from './file_attachment_menu';

import type {OwnProps, PropsFromRedux} from './index';

type Props = OwnProps & PropsFromRedux;

export const FileAttachmentList = (props: Props) => {
    const {
        actions, post, compactDisplay, fileInfos, fileIds, isInPermalink, interactive = true,
        isEmbedVisible, canDownloadFiles, enablePublicLink, pluginMenuItems,
    } = props;
    const intl = useIntl();
    const {onLogPostAction} = useContext(PostContext);

    const handleAttachmentClick = (fileInfo: FileInfo) => {
        if (!interactive) {
            return;
        }

        onLogPostAction('attachment', 'click');
        actions.openModal({
            modalId: ModalIdentifiers.FILE_PREVIEW_MODAL,
            dialogType: FilePreviewModal,
            dialogProps: {
                postId: post.id,
                fileInfos,

                //TODO: rework FilePreviewModal to use fileInfo directly insted of using index in fileInfos array
                startIndex: fileInfos.indexOf(fileInfo),
            },
        });
    };
    const renderMenuItems = (fileInfo: FileInfo) => {
        return (
            <FileAttachmentMenu
                pluginMenuItems={pluginMenuItems}
                fileInfo={fileInfo}
                enablePublicLink={enablePublicLink}
                openModal={actions.openModal}
            />
        );
    };
    const getFilePublicLink = async (id: string) => {
        const res = await actions.getFilePublicLink(id);

        return res.data?.link ?? '';
    };
    const onDownloadAttachment = (fileInfo: FileInfo) => {
        sendToStatist('app.fileDownloaded', {
            channelid: post.channel_id,
            messageId: post.id,
            fileId: fileInfo.id,
        });
        onLogPostAction('download', 'click');
    };

    return (
        <FileAttachmentsList
            postId={post.id}
            intl={intl}
            compactDisplay={compactDisplay}
            fileInfos={fileInfos}
            fileIds={fileIds}
            isInPermalink={isInPermalink}
            interactive={interactive}
            isEmbedVisible={isEmbedVisible}
            canDownloadFiles={canDownloadFiles}
            enablePublicLink={enablePublicLink}
            renderMenuItems={renderMenuItems}
            getFileUrl={getFileUrl}
            getThumbnailUrl={getFileThumbnailUrl}
            getDownloadUrl={getFileDownloadUrl}
            getFilePublicLink={getFilePublicLink}
            getFilePreviewUrl={getFilePreviewUrl}
            toggleEmbedVisibility={actions.toggleEmbedVisibility}
            handleAttachmentClick={handleAttachmentClick}
            handleCopyToClipboard={copyToClipboard}
            onDownloadAttachment={onDownloadAttachment}
        />
    );
};

export default FileAttachmentList;
